import AppLayout from "../../components/layout/app.layout";

export const Orders = ({}) => {
  return <AppLayout>Orders</AppLayout>;
};
